import { useMutation } from '@tanstack/react-query'

import { request } from '../api'

// Transport is request() from ../api, not apiFetch: on a non-ok response the
// server puts the failure reason in the body, and request() throws it as the
// Error message — that message is what the alert reducer shows the user.
// apiFetch would throw "HTTP status 400" and drop the body. request() also
// sends credentials: 'include', which the session-cookie sales-start flow
// needs.
export const useCreateInterestSignup = () =>
  useMutation({
    mutationFn: ({ projectId, user }) =>
      request({
        method: 'POST',
        url: '/api/user/interest-signup',
        body: { projectId, user },
      }),
  })

export const useCreateSalesStartSignup = () =>
  useMutation({
    mutationFn: ({ projectId }) =>
      request({
        method: 'POST',
        url: '/api/user/sales-signup',
        body: { projectId },
      }),
  })

export const useUpdateSalesStartSignup = () =>
  useMutation({
    mutationFn: (user) =>
      request({
        method: 'PUT',
        url: '/api/user/sales-signup',
        body: user,
      }),
  })
